define('AwaLabs.CustomProductListName.Main', [
    'Item.KeyMapping',
    'underscore'
],
function CustomProductListName(
    ItemKeyMapping,
    _
) {
    'use strict';

    _.extend(ItemKeyMapping, {
        getKeyMapping: _.wrap(ItemKeyMapping.getKeyMapping, function getKeyMapping(fn) {
            var keyMapping = fn.apply(this, _.toArray(arguments).slice(1));

            _.extend(keyMapping, {
                _name: function _name(item) {
                    var itemId = item.get('itemid') || '';
                    var parent = item.get('_matrixParent');
                    var storedDisplayName = item.get('storedisplayname2');
                    var displayName = item.get('displayname');
                    var sku = item.get('_sku');
                    var matches;

                    if (parent.get('internalid')) {
                        storedDisplayName = parent.get('storedisplayname2');
                        displayName = parent.get('displayname');
                        sku = parent.get('_sku');
                        matches = itemId.match(/:(.*)/);

                        return storedDisplayName && storedDisplayName !== itemId && storedDisplayName !== sku
                            ? storedDisplayName
                            : displayName || (matches && matches[1]) || storedDisplayName || itemId;
                    }

                    return storedDisplayName && storedDisplayName !== itemId && storedDisplayName !== sku
                        ? storedDisplayName
                        : displayName || storedDisplayName || itemId;
                }
            });

            return keyMapping;
        })
    });
});
